(function($){	
setTimeout(function() {
        $('#review_slider').owlCarousel({
        margin: 27,
        loop: true,
        slideSpeed: 300,
        paginationSpeed: 400,
        autoplay: true,
        nav: true,
        pagination: true,
        dots: false,
        navText: [
            "<img src='https://cdn.shopify.com/s/files/1/0640/7998/6735/files/previous-arrow.png?v=1744625629' alt='Previous'>",
            "<img src='https://cdn.shopify.com/s/files/1/0640/7998/6735/files/next.png?v=1744625629' alt='Next'>"
        ],
        responsive: {
            0: { items: 1 },
            480: { items: 1 },
            700: { items: 2 },
            1000: { items: 3 },
            1100: { items: 3 }
        }
    }); 
    }, 2000);
	}) (jQuery);	


// Blog Load More JS Start
document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.getElementById("load-more");
  if (!loadMoreBtn) return;

  loadMoreBtn.addEventListener("click", function () {
    const nextPageUrl = loadMoreBtn.getAttribute("data-next");
    if (!nextPageUrl) return;

    loadMoreBtn.textContent = "Loading...";

    fetch(nextPageUrl)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, "text/html");

        const newArticles = htmlDoc.querySelectorAll(".blog-articles__article");
        const articleWrapper = document.querySelector(".blog-articles");

        newArticles.forEach(article => {
          articleWrapper.appendChild(article);
        });

        const newButton = htmlDoc.querySelector("#load-more");
        if (newButton) {
          loadMoreBtn.setAttribute("data-next", newButton.getAttribute("data-next"));
          loadMoreBtn.textContent = "Load More";
        } else {
          loadMoreBtn.remove();
        }
      })
      .catch(error => {
        console.error("Load More error:", error);
        loadMoreBtn.textContent = "Load More";
      });
  });
});

// Blog Load More JS End


// Collection FAQ JS Start

    jQuery(".s-faq-area .accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".s-faq-area .accordion-box .accordion_body").slideUp();
      $(".s-faq-area .accordion-box").removeClass("open");
      $(this).closest(".s-faq-area .accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".s-faq-area .accordion-box").toggleClass("open");
    }
    else
    {
      $(".s-faq-area .accordion-box .accordion_body").slideUp();
      $(".s-faq-area .accordion-box").removeClass("open");
    }
  });

// Collection FAQ JS End


// Announcement Bar Hide JS Start

if (Shopify.country === "CA") {
  $(".announcement-canada-only").show();
} else {
  $(".announcement-canada-only").hide();
}

// Announcement Bar Hide JS End



  document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.getElementById("localizationToggle");
    const dropdown = document.getElementById("localizationDropdown");

    if (toggle && dropdown) {
      toggle.addEventListener("click", function (e) {
        e.stopPropagation();
        dropdown.classList.toggle("hidden");
      });

      // Close dropdown when clicking outside
      document.addEventListener("click", function (e) {
        if (!dropdown.contains(e.target) && !toggle.contains(e.target)) {
          dropdown.classList.add("hidden");
        }
      });
    }
  });





